<div class="card">
  <div class="card-body">
    <h5 class="header-title mb-3">{{ 'channel.templateBuilder.previewTitle' | translate }}</h5>

    <!-- The whole WhatsApp rendering — phone shell, header, bubble, buttons, timestamp — belongs to
         lib-trend-core. This screen only feeds it. -->
    <chat-wa-preview [title]="title" [message]="message" [footer]="footer" [buttons]="buttons"
      [templateType]="templateType" [mediaSrc]="mediaSrc" />
  </div>
</div>
